<template>
  <div v-if="visible" class="w-full h-full fixed inset-0 flex flex-col items-center justify-center bg-gray-900 bg-opacity-75 fullscreen">
    <i class="fa-solid fa-spinner fa-6x animate-spin loading-effect spinnerClass"></i>
    <p class="text-xl mt-4 textClass">{{ text }}</p>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'Cargando...'
    },
    visible: {
      type: Boolean,
      required: true
    },
  }
};
</script>

<style>
.fullscreen{
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    top: 0;
    left: 0;
    z-index: 10000;
    background-color: rgb(255, 255, 255);
}
.spinnerClass{
    color: #2e827d;
}
@keyframes loadingEffect {
  0% { transform: rotate(0deg); opacity: 1; }
  50% { opacity: 0.5; }
  100% { transform: rotate(360deg); opacity: 1; }
}

.loading-effect {
  animation: loadingEffect 1.5s infinite ease-in-out;
}
</style>